import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import templateServices from '../../services/TemplateServices';
import _ from 'lodash';
import { LocalePath } from '../../common/Foundation';
import { translate } from 'react-i18next';
import BackToTopComponent from '../CompactView/BackToTopComponent';
import { isHomePageSelector } from '../../slices/LayoutTemplateSlice';
import CommonUtil from '../../common/CommonUtil';

const FooterComponent = (props) => {
  const templateData = useSelector(state => state.LayoutTemplateSlice.templateData);
  const currentViewContainer = useSelector(state => state.LayoutTemplateSlice.currentViewContainer);
  const user = useSelector(state => state.AccountsSlice.user);
  const isHomePage = useSelector(isHomePageSelector);
  const isSmallLayout = useSelector(state => state.LayoutTemplateSlice.isSmallLayout);
  const comps = templateServices.listComponentsByDataNoGrid(getFooterComponents(), props.router) || (<div/>)
  const { auth, type } = user;
  const isWL = CommonUtil.isWhitelabel();

  let locale = props.i18n.language;
  function getFooterComponents() {
    const footerCompNames = templateData.footerCompNames || {};
    let dataComps = [];
    let componentsByView = footerCompNames[currentViewContainer];
    if (componentsByView != null && componentsByView.length > 0) {
      dataComps = componentsByView || [];
    } else {
      dataComps = footerCompNames.formal || [];
    }
    return dataComps
  }

  let langPath = (_.invert(LocalePath))[locale];
  return (
    <div id="footer" className={`${langPath} ${auth ? 'auth' : 'noauth'} ${isHomePage ? 'landing-footer' : ''} ${type} ${isWL ? 'footer_whitelabel_type' : ''}`}>
      <div className="footer-wrapper">
        {comps}
      </div>
      {isSmallLayout && <BackToTopComponent isDisplay={true}/>}
      
    </div>
  );
}

export default translate()(FooterComponent);



// WEBPACK FOOTER //
// ./src/app/components/FooterComponent/index.js